export type RegistryItem = {
  type: string; // 'texto', 'imagem', etc
  label: string;
  defaultProps: Record<string, any>;
};

export const REGISTRY: RegistryItem[] = [
  { type: 'texto', label: 'Texto', defaultProps: { text: 'Novo texto' } },
  { type: 'imagem', label: 'Imagem', defaultProps: { src: '', alt: '' } },
  { 
    type: 'cronometro', 
    label: 'Cronômetro', 
    defaultProps: { 
      timerType: 'minutes',
      backgroundColor: '#ef4444',
      textColor: '#ffffff',
      timeValue: 15,
      activeText: 'Oferta por tempo limitado',
      expiredText: 'O tempo acabou!',
      fixedTop: false
    } 
  },
  {
    type: 'avaliacao',
    label: 'Avaliação',
    defaultProps: {
      name: 'Nome do cliente',
      text: 'Escreva aqui a avaliação do seu cliente.',
      stars: 5,
      avatarUrl: '',
      horizontal: false
    }
  },
  {
    type: 'lista',
    label: 'Lista',
    defaultProps: {
      listType: 'check',
      align: 'left',
      backgroundColor: '',
      title: '',
      itemColor: '#555555',
      iconColor: '',
      itemSize: 18,
      items: ['Primeiro item da lista', 'Segundo item da lista']
    }
  },
  {
    type: 'vantagens',
    label: 'Vantagens',
    defaultProps: {
      theme: 'light',
      privacy: true,
      secure: true,
      email: true,
      approved: true,
      mainColor: '#1E88E5',
      titleColor: '#0D2A3A'
    }
  },
];
